export default "__VITE_ASSET__DnmOEd7L__"